// Carousels and keyboard focus (WCAG 2.4.7 / 2.4.11): when Tab moves focus to a
// card that is outside the carousel's visible area, show that card straight
// away instead of after the slide animation, so the focused card is never off
// screen. Mouse and touch focus are left alone.
let keyboard = false;

document.addEventListener("keydown", (event) => {
    keyboard = event.key === "Tab";
}, true);
document.addEventListener("pointerdown", () => {
    keyboard = false;
}, true);

document.addEventListener("focusin", (event) => {
    const slide = keyboard && event.target.closest ? event.target.closest(".swiper-slide") : null;
    const container = slide && slide.closest(".swiper");
    const swiper = container && container.swiper;
    if (!swiper || swiper.destroyed) {
        return;
    }
    const box = container.getBoundingClientRect();
    const rect = slide.getBoundingClientRect();
    if (rect.left >= box.left - 1 && rect.right <= box.right + 1) {
        return;
    }
    const index = swiper.slides.indexOf(slide);
    if (swiper.params.loop && slide.hasAttribute("data-swiper-slide-index")) {
        swiper.slideToLoop(Number(slide.getAttribute("data-swiper-slide-index")), 0);
    } else if (index > -1) {
        swiper.slideTo(index, 0);
    }
});
